import type { SxProps, Theme } from '@mui/material/styles';

import type { SystemStyleObject } from '@mui/system';

/** Compact icon-only layout for list rows on narrow viewports. */
export const subscriptionIconOnlyButtonSx: SxProps<Theme> = (theme) => ({
  minWidth: 40,
  minHeight: 40,
  padding: theme.spacing(0.75),
  '& .MuiButton-startIcon': {
    margin: 0,
  },
});

function resolveSxToObject(
  theme: Theme,
  sx: SxProps<Theme>,
): SystemStyleObject<Theme> {
  if (typeof sx === 'function') {
    return sx(theme) as SystemStyleObject<Theme>;
  }
  if (Array.isArray(sx)) {
    return Object.assign({}, ...sx) as SystemStyleObject<Theme>;
  }
  return sx as SystemStyleObject<Theme>;
}

/** Merges icon-only layout with `sx` as a single `SxProps` (Button typings reject `sx` arrays). */
export function mergeSubscriptionButtonSx(
  iconOnly: boolean | undefined,
  sx: SxProps<Theme> | undefined,
): SxProps<Theme> | undefined {
  if (!iconOnly) {
    return sx;
  }
  if (sx == null) {
    return subscriptionIconOnlyButtonSx;
  }
  return (theme: Theme): SystemStyleObject<Theme> => {
    const base =
      typeof subscriptionIconOnlyButtonSx === 'function'
        ? (subscriptionIconOnlyButtonSx(theme) as SystemStyleObject<Theme>)
        : (subscriptionIconOnlyButtonSx as SystemStyleObject<Theme>);
    const extra = resolveSxToObject(theme, sx);
    return { ...base, ...extra };
  };
}
